import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Lozenge from '@atlaskit/lozenge';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import {
	type Color,
	type ColorSchema,
	PURPLE,
} from '@atlassian/jira-issue-epic-color-types/src/types.tsx';
import { transformColorToTheme } from '@atlassian/jira-issue-epic-color/src/common/utils.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';

type Props = {
	color?: Color;
	children: ReactNode;
};

type LozengeTheme = {
	backgroundColor: string;
	color: string;
};

const LOZENGE_THEMES: Record<Color, LozengeTheme> = transformColorToTheme(
	(colorSchema: ColorSchema) => ({
		color: colorSchema.text,
		backgroundColor: colorSchema.textBackground,
	}),
);

const getLozengeThemeByColor = (color: Color) =>
	// This uses schema from src/packages/issue/epic-color/src/common/constants.js
	LOZENGE_THEMES[color] || LOZENGE_THEMES[PURPLE];

const CardEpic = (props: Props) => {
	// This uses schema from src/packages/issue/epic-color/src/common/constants.js
	const { color = PURPLE, children } = props;
	/* eslint-disable jira/react/no-style-attribute */
	return (
		<LozengeWrapper data-testid="platform-board-kit.ui.swimlane.epic.lozenge">
			<Lozenge
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
				style={getLozengeThemeByColor(color)}
				isBold={isVisualRefreshEnabled()}
			>
				{children}
			</Lozenge>
		</LozengeWrapper>
	);
	/* eslint-enable jira/react/no-style-attribute */
};

export default CardEpic;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LozengeWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& span': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
		lineHeight: `${gridSize * 2}px`,
	},
});
